/**
 * Для картинок с названиями такого вида "imgName-ru.jpg", "imgName-en.jpg", "imgName-es.jpg"
 * Используем эту функцию, чтобы для каждого языка отображалась соответствующая ему картинка.
 * Если для какого-то языка нет картинки, ему покажется по умолчанию 'en', либо значение из параметра reserveLng, если оно указано при вызове функции
 * @example
 * const { i18n: { language }} = useTranslation('mainPage');
 * const imgLanguage = getImageLang(language, ['en', 'ru']);
 * <img src={`https://investment-s3.unitedtraders.com/main-page/imgName-${imgLanguage}.png`} alt="" />
 */

export const getImageLang = (
  lng: string,
  availableLng: string[] = ['en', 'es', 'ru'],
  reserveLng = 'en'
) => (availableLng.includes(lng) ? lng : reserveLng);
